module.exports = __webpack_public_path__ + "static/img/icon_zongxaidanshu.ef4ff698.png";